import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const Loading = ({ size = 48 }) => {
  return (
    <Spin
      data-testid="loading-spinner"
      indicator={
        <LoadingOutlined style={{ fontSize: size, color: 'var(--purple-3)' }} />
      }
      style={{ display: 'block' }}
    />
  );
};

export default Loading;
